import { FunctionalType } from '../types/functional.type'
import { HiddenFunctionalByRoles } from '../consts/hidden-functional-by-roles'
import { RolesEnum } from '../../modules/general/users/core/enums/roles.enum'

export function checkVisibleFunctional(functional: FunctionalType, role: RolesEnum): boolean {
	if (!role || !HiddenFunctionalByRoles[role]) return false
	return !HiddenFunctionalByRoles[role].includes(functional)
}